<template>
  <div class="upload_opus">
    <el-form :model="form" ref="form" label-width="10px">
      <div class="upload_opus_inner m">
        <div class="upload_opus_area">
          <h3>上传作品</h3>
          <!-- 上传作品图片组件部分 -->
          <upload_opus :params="params"></upload_opus>
        </div>
        <!-- 上传封面 -->
        <div class="upload_opus_area">
          <h3>上传作品封面</h3>
          <!-- 上传作品图片组件部分 -->
          <div style="display:flex;">
            <i style="color:red">*</i>
            <AppCropper :params="form" @uploadObj="uploadObj" />
          </div>
        </div>

        <!-- ~~~~~~~~~ -->
        <!-- 作品信息部分 -->
        <div class="opus_info">
          <h3>作品信息</h3>
          <div class="info_area">
            <el-form-item
              prop="name"
              class="opus_name"
              :rules="[{ required: true, message: '请输入作品名称', trigger: 'blur'}]"
            >
              <el-input v-model="form.name" placeholder="请输入作品名称" maxlength="50" show-word-limit></el-input>
            </el-form-item>
            <el-form-item prop="permission" class="visible">
              <el-select v-model="form.permission" placeholder>
                <el-option label="自己可见" value="OpusPermsPrivate"></el-option>
                <el-option label="所有人可见" value="OpusPermsPublic"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="synopsis">
              <el-input
                v-model="form.synopsis"
                placeholder="输入作品简介"
                maxlength="650"
                show-word-limit
                type="textarea"
              ></el-input>
            </el-form-item>
            <el-form-item prop="video" label=" ">
              <uploadVideo
                :params="form"
                :apiParams="apiParams4"
                @authProgress="highlightsProgress"
              ></uploadVideo>
            </el-form-item>
          </div>
        </div>
        <div class="pub_box">
          <div class="pub_tit">
            <h3>创作花絮</h3>
          </div>
          <div class="pub_content">
            <el-form-item prop="is_highlight" label="发布花絮" label-width="80px">
              <el-switch
                v-model="form.is_highlight"
                active-color="#13ce66"
                inactive-color="#f0f0f0"
              ></el-switch>
            </el-form-item>
            <el-form-item label=" " prop="highlight_image_details">
              <upload_opus :params="params2" @uploadSucess="uploadSucess"></upload_opus>
            </el-form-item>

            <el-form-item prop="highlight_synopsis" label=" ">
              <el-input
                v-model="form.highlight_synopsis"
                placeholder="请说明作品创作历程等相关花絮（选填）"
                maxlength="650"
                show-word-limit
                type="textarea"
                :rows="6"
              ></el-input>
            </el-form-item>

            <el-form-item prop="highlight_video" label=" ">
              <uploadVideo
                :params="form"
                :apiParams="apiParams5"
                @authProgress="highlightsProgress"
              ></uploadVideo>
            </el-form-item>
          </div>
        </div>
        <!-- 添加标签部分 -->
        <tags :tags_list="tags_list"></tags>

        <div class="btn">
          <template v-if="$route.query.id">
            <el-button type="primary" @click="edit(true)">保存并返回</el-button>
            <el-button type="primary" @click="edit(false)">保存并添加获奖信息</el-button>
          </template>
          <template v-else>
            <el-button type="primary" @click="submit(true)">保存并返回</el-button>
            <el-button type="primary" @click="submit(false)">保存并添加获奖信息</el-button>
          </template>
        </div>
      </div>
    </el-form>
  </div>
</template>
<script>
import upload_opus from "@/components/upload_opus/index.vue";
import AppCropper from "@/components/file_upload/Cropper.vue";
import tags from "@/components/tags/index.vue";
import uploadVideo from "@/components/file_upload/uploadVideo.vue";
export default {
  components: {
    upload_opus,
    tags,
    AppCropper,
    uploadVideo
  },
  data() {
    return {
      form: {
        name: "",
        permission: "OpusPermsPublic",
        synopsis: "",
        key_word: "",
        image_details: "",
        cover: "",
        is_highlight:false
      }, //作品信息表单

      prize_list: [],
      params: {
        //上传作品组件参数
        img_list: [] //上传图片列表
      },
      params2: {
        name: "test2",
        fileId: "highlight_image_details",
        img_list: [] //花絮作品列表
      },
      apiParams: {
        params: {
          //文件上传所需要的参数
          catalog: "CatalogUserHead",
          loginKey: ""
        },
        imgPath: "imgPath", //文件路径字段
        fileId: "imageIds" //文件id字段
      },
      apiParams4: {
        params: {
          //文件上传所需要的参数
          catalog: "CatalogWhaleVideo",
          loginKey: ""
        },
        style: 1,
        imgPath: "videoPath", //文件路径字段
        fileId: "video" //文件id字段
      },
      apiParams5: {
        params: {
          //文件上传所需要的参数
          catalog: "CatalogWhaleVideo",
          loginKey: ""
        },
        style: 1,
        imgPath: "highlight_videoPath", //文件路径字段
        fileId: "highlight_video" //文件id字段
      },
      tags_list: [], //标签列表
      opus_obj: {}, //编辑作品传递过来的作品信息
      opus_id: "", //作品上传提交后返回的作品id
      videoProgress: 100, //视频进度
      highlight_videoProgress: 100 //视频进度
    };
  },
  computed: {
    info() {
      return this.$store.state.info;
    },
    designer() {
      return this.$store.state.designer;
    }
  },
  created() {
    // console.log(this.$route.params.opus_obj);
    if (this.$route.query.id) {
      this.opus_id = this.$route.query.id;
      if (this.info) {
        this.getOpuses();
      } else {
        this.needInfo("getOpuses");
      }
    }
  },
  methods: {
    // 截图后返回的路径和id
    uploadObj(obj) {
      this.form = Object.assign({}, this.form, {
        cover: obj.fileId
      });
    },
    needInfo(fn) {
      let watcher = this.$watch("info", (val, oldVal) => {
        if (val) {
          this[fn]();
          watcher();
        }
      });
    },

    // 获取作品信息
    getOpuses() {
      let obj = {
        id: this.opus_id,
        active: true,
        is_examine: true,
        user_id: this.info.id
      };
      this.api.getOpuses(obj).then(res => {
        console.log(res);
        if (res.error.err_code !== 0) return;
        let list = res.obj.list;
        this.opus_obj = list[0] || null;
        this.initEdit();
      });
    },
    // 初始化编辑页面
    initEdit() {
      let opus_obj = this.opus_obj;
      const {
        name,
        key_word,
        permission,
        cover,
        coverPath,
        is_highlight,
        highlight_synopsis,
        highlight_image_details,
        highlight_image_detailsPath,
        video,
        videoName,
        videoPath,
        highlight_video,
        highlight_videoName,
        highlight_videoPath,
        synopsis
      } = { ...opus_obj };
      let imgid2 = highlight_image_details.length
        ? highlight_image_details.split(",")
        : []; //花絮作品id
      let img_list2 = highlight_image_detailsPath.length
        ? highlight_image_detailsPath.split("|")
        : []; //花絮作品id
      let img2arr = [];
      for (let i = 0; i < imgid2.length; i++) {
        img2arr.push({
          fileId: imgid2[i],
          filePath: img_list2[i]
        });
      }

      this.params2 = Object.assign({}, this.params2, {
        img_list: img2arr
      });
      this.form = Object.assign({}, this.form, {
        name,
        key_word,
        permission,
        cover,
        coverPath,
        is_highlight,
        highlight_synopsis,
        highlight_image_details,
        highlight_image_detailsPath,
        video,
        videoName,
        videoPath,
        highlight_video,
        highlight_videoName,
        highlight_videoPath,
        synopsis
      });
      // this.form.name = this.opus_obj.name;
      // this.form.synopsis = this.opus_obj.synopsis;
      // this.form.key_word = this.opus_obj.key_word;
      // this.form.permission = this.opus_obj.permission;
      // this.form.cover = this.opus_obj.cover;
      // 初始化上传作品图片列表
      let id_list = opus_obj.image_details
        ? opus_obj.image_details.split(",")
        : [];
      let pic_list = opus_obj.image_detailsPath
        ? opus_obj.image_detailsPath.split("|")
        : [];
      for (let i = 0; i < id_list.length; i++) {
        let obj = {
          fileId: id_list[i],
          filePath: pic_list[i]
        };
        this.params.img_list.push(obj);
      }
      // 初始化标签选择
      this.tags_list = this.form.key_word.split(",");
      // this.initPrize();
    },

    // 提交上传作品
    submit(flag) {
      if (this.videoProgress < 100) {
        this.$message.info("作品视频上传中，请稍后!");
        return;
      }
      if (this.highlight_videoProgress < 100) {
        this.$message.info("花絮视频上传中，请稍后!");
        return;
      }
      this.form.key_word = this.tags_list.join(",");
      let img_list = this.params.img_list.map(item => {
        return item.fileId;
      });
      this.form.image_details = img_list.join(",");
      let obj = Object.assign({}, this.form, {
        user_id: this.info.id,
        designer: this.designer.id
      });
      if (!this.form.cover) {
        this.$message.warning("请上传作品封面！");
        return;
      }
      if (!img_list.length) {
        this.$message.warning("作品图片不能为空！");
        return;
      }
      if (!this.form.name) {
        this.$message.warning("作品名称不能为空！");
        return;
      }
      if (!this.tags_list.length) {
        this.$message.warning("作品标签不能为空！");
        return;
      }
      obj.coverPath && delete obj.coverPath;
      this.api.createOpus(obj).then(res => {
        console.log(res);
        if (res.error.err_code !== 0) return;
        this.opus_id = res.obj.opusId;
        // flag 用来识别是否跳转添加获奖情况页面
        if (flag) {
          this.$message.success("上传作品成功！");
          this.$router.push({ name: "personal_center_works" });
        } else {
          this.$router.push({
            name: "upload_prize",
            query: {
              prize_opus_id: this.opus_id,
              flag: true
            }
          });
        }
      });
    },

    // 编辑作品
    edit(flag) {
      this.form.key_word = this.tags_list.join(",");
      let img_list = this.params.img_list.map(item => {
        return item.fileId;
      });
      if (!img_list.length) {
        this.$message.warning("作品图片不能为空！");
        return;
      }
      if (!this.form.name) {
        this.$message.warning("作品名称不能为空！");
        return;
      }
      if (!this.tags_list.length) {
        this.$message.warning("作品标签不能为空！");
        return;
      }

      this.form.image_details = img_list.join(",");
      let obj = Object.assign({}, this.form, {
        id: this.opus_id
      });

      this.api.updateOpus(obj).then(res => {
        if (res.error.err_code !== 0) return;
        // flag 用来识别是否跳转添加获奖情况页面
        if (flag) {
          this.$router.push({ name: "personal_center_works" });
          this.$message.success("修改作品成功！");
        } else {
          this.$router.push({
            name: "upload_prize",
            query: {
              prize_opus_id: this.opus_id,
              flag: false
            }
          });
        }
      });
    },
    //图片作品上传成功后的处理
    uploadSucess(res) {
      let obj = {};
      let list = [];
      res.img_list.forEach(item => {
        list.push(item.fileId);
      });
      list = list.length ? list.join(",") : "";
      obj[res.fileId] = list;
      this.form = Object.assign({}, this.form, obj);
    },
    // 视频上传进度（返回的是1-100的数值）
    highlightsProgress(pros) {
      let name = pros.fileName + "progress";
      this[name] = pros.authProgress;
      console.log(pros);
    }
  }
};
</script>
<style lang="scss">
.upload_opus {
  .pub_box {
      background: #fff;
      .pub_tit {
        padding: 30px 30px 20px;
        h3 {
          font-size: 16px;
          font-weight: bold;
          color: rgba(51, 51, 51, 1);
        }
      }
      .pub_content {
        padding: 0 30px 10px;
      }
    }
    .pub_box + .pub_box {
      margin-top: 10px;
    }
  .upload_opus_inner {
    padding-top: 20px;
    padding-bottom: 60px;
    h3 {
      font-size: 16px;
      color: #333;
      font-weight: 600;
      line-height: 56px;
    }
    .upload_opus_area {
      width: 100%;
      // height: 277px;
      background: #fff;
      box-sizing: border-box;
      padding: 10px 30px 20px;
      margin-bottom: 10px;
      .upload_btn:before {
        content: "*";
        position: absolute;
        top: 5px;
        left: -10px;
        color: #f93333;
        font-size: 18px;
      }
    }
    .opus_info {
      width: 100%;
      // height: 277px;
      background: #fff;
      box-sizing: border-box;
      padding: 10px 30px 20px;
      margin-bottom: 10px;
      .info_area {
        .opus_name {
          position: relative;
        }
        .opus_name:before {
          content: "*";
          position: absolute;
          top: 5px;
          left: 0px;
          color: #f93333;
          font-size: 18px;
        }
        .visible {
          input {
            width: 320px;
          }
        }
      }
    }

    .btn {
      height: 54px;
      display: flex;
      align-items: center;
      button {
        // width: 90px;
        height: 34px;
        background-color: #111;
      }
      button:hover {
        opacity: 0.7;
        background: #111;
        border-color: #111;
        color: #ffffff;
      }
    }
  }
}
</style>